export const en = {
  // Navigation
  documentList: 'Document List',
  uploadDocument: 'Upload Document',
  contactUs: 'Contact Us',
  profile: 'Profile',
  login: 'Login',
  logout: 'Logout',
  aboutUs: 'About Us',
  apiReference: 'API Reference',
  integration: 'Integration',
  navWorkspace: 'Workspace',
  navResources: 'Resources',
  navAccount: 'Account',
  navBackToDocuments: 'Back to documents',
  menu: 'Menu',

  // Common
  version: 'Version',
  language: 'Language',

  // Upload Document
  stepSelectOrganisation: 'Select organisation',
  step2: 'Signers',
  step3: 'Document Information',
  step4: 'Upload',
  documentTitle: 'Document Title',
  moreDocumentDetails: 'More details',
  hideDocumentDetails: 'Hide details',
  uploadOperationIdLabel: 'Operation / reference no.',
  uploadOperationIdPlaceholder: 'e.g. contract no., sales order no.',
  uploadOperationIdHint: 'Optional. Your internal reference for this signing request.',
  description: 'Description',
  expireDate: 'Expire Date',
  summary: 'Summary',
  addSigner: 'Add Signer',
  addMeAsSigner: 'Add me as a signer',
  alreadyAddedAsSigner: 'You are already included as a signer.',
  addMeAsSignerNoEmail: 'Your profile does not include an email address.',
  addMeAsSignerPromo: 'Signing only for yourself? Fill your details in one tap.',
  uploadStepValidationIntro: 'Complete the highlighted fields before continuing.',
  uploadSignerOptionalSection: 'Contact and ID (optional)',
  uploadFinOptionalHint: 'Leave FIN empty unless needed. If entered, it must be 7 characters.',
  uploadMoreSignerTin: 'VOEN / TIN',
  uploadHideSignerTin: 'Hide VOEN / TIN',
  uploadTinOptionalHint: 'Optional. If entered, VOEN must be 10 digits.',
  uploadUnsavedLeaveWarning: 'You have unsaved upload progress. Leave this page anyway?',
  uploadOptionalSuffix: 'optional',
  signerLabel: 'Signer',
  signerName: 'Name',
  signerSurname: 'Surname',
  signerEmail: 'Email',
  signerPhone: 'Phone',
  signerRole: 'Role',
  roleSigner: 'Signer',
  roleVisa: 'Visa',
  delete: 'Delete',
  next: 'Next',
  back: 'Back',
  submit: 'Submit',
  cancel: 'Cancel',
  
  // Document List
  documents: 'Documents',
  noDocuments: 'No documents',
  
  // Profile
  profileTitle: 'Profile',
  name: 'Name',
  surname: 'Surname',
  email: 'Email',
  phone: 'Phone',
  save: 'Save',

  // Login/Register
  emailLabel: 'Email',
  password: 'Password',
  rememberMe: 'Remember me',
  forgotPassword: 'Forgot password?',
  username: 'Username',
  usernameRequired: 'Username is required',
  invalidUsernameFormat: 'Use 2–64 letters, numbers, dots, underscores, or hyphens',
  usernameHelper: 'Letters, numbers, . _ - only',
  register: 'Register',
  alreadyHaveAccount: 'Already have an account?',
  dontHaveAccount: 'Don\'t have an account?',
  
  // Errors and Messages
  required: 'This field is required',
  invalidEmail: 'Invalid email address',
  invalidPhone: 'Invalid phone number',
  nameRequired: 'Name is required',
  surnameRequired: 'Surname is required',
  emailRequired: 'Email is required',
  passwordRequired: 'Password is required',
  finRequired: 'FIN code is required',
  phoneRequired: 'Phone number is required',
  titleRequired: 'Title is required',
  expireDateRequired: 'Expire date is required',
  invalidEmailFormat: 'Invalid email format',
  invalidPhoneFormat: 'Invalid phone number format',
  invalidPhoneLength: 'Invalid phone number (use digits, optional +, 7-15 length)',
  passwordMinLength: 'Password must be at least 6 characters',
  passwordsDoNotMatch: 'Passwords do not match',
  finCodeLength: 'FIN code must be 7 characters',
  tinCodeLength: 'TIN code must be 10 digits',
  selectOrganisation: 'Please select an organisation',
  addAtLeastOneSigner: 'Please add at least one signer',
  selectFile: 'Please select a PDF file to upload.',
  selectPdfFile: 'Only PDF files are allowed. Please select a PDF file.',
  organisationNotSelected: 'Organisation not selected. Please go back and select an organisation.',
  uploadFailed: 'Failed to upload and submit document info. Please try again.',
  loginFailed: 'Login failed. Please try again.',  uploadInProgress: 'Upload in progress...',
  uploadInProgressHint: 'Please wait while the document is uploaded and submission is completed.',
  uploading: 'Uploading...',

  registrationFailed: 'Registration failed. Please try again.',
  
  // Login/Register Extended
  signIn: 'Sign In',
  signUp: 'Sign Up',
  signingIn: 'Signing in...',
  creatingAccount: 'Creating Account...',
  signInToAccount: 'Sign in to your mySign.az account',
  createAccount: 'Create your mySign.az account',
  keepMeLoggedIn: 'Keep me logged in',
  emailAddress: 'Email Address',
  confirmPassword: 'Confirm Password',
  phoneNumber: 'Phone Number',
  finCode: 'FIN Code',
  finCodeHelper: '7 characters',

  recoverPasswordTitle: 'Recover password',
  recoverPasswordDescription: 'Enter your email address and we will send you a link to reset your password.',
  sendResetLink: 'Send reset link',
  sendingResetLink: 'Sending…',
  resetEmailSent:
    'If an account exists for that email, you will receive reset instructions shortly. Check your inbox.',
  resetPasswordTitle: 'Set new password',
  resetPasswordDescription: 'Choose a new password for your account.',
  newPassword: 'New password',
  setNewPassword: 'Update password',
  updatingPassword: 'Updating…',
  backToSignIn: 'Back to sign in',
  invalidResetLink: 'This reset link is invalid or incomplete. Request a new link below.',
  passwordResetSuccess: 'Your password was updated. You can sign in now.',
  passwordResetFailed: 'Could not reset password. The link may have expired.',
  requestPasswordResetFailed: 'Could not send reset email. Please try again.',
  
  confirmEmailTitle: 'Email confirmation',
  confirmingEmail: 'Confirming your email...',
  confirmEmailSuccess: 'Thanks for confirming your email. You can sign in now.',
  confirmEmailSuccessHint: 'Your email is confirmed. Redirecting to sign in...',
  confirmEmailFailed: 'Could not confirm your email. The link may be invalid or expired.',
  confirmEmailFailedHint: 'Please try the link again or request a new confirmation email.',
  invalidConfirmEmailLink: 'This confirmation link is invalid or incomplete.',

  // Document List Extended
  documentListTitle: 'Document List',
  viewAllDocuments: 'View all your documents',
  noDocumentsFound: 'No Documents Found',
  noDocumentsYet: 'You don\'t have any documents yet.',
  pleaseLoginToView: 'Please log in to view your documents.',
  failedToLoadDocuments: 'Failed to load documents. Please try again.',
  title: 'Title',
  expirationDate: 'Expiration Date',
  status: 'Status',
  actions: 'Actions',
  view: 'View',
  operation: 'Operation',
  unknown: 'Unknown',
  untitledDocument: 'Untitled Document',
  documentFilters: 'Filters',
  signingStatusFilter: 'Signing status',
  signStatusAll: 'All',
  signStatusSigned: 'Completed',
  signStatusPending: 'In progress',
  createdFromFilter: 'Created from',
  expiresBeforeFilter: 'Expires on or before',
  operationIdFilter: 'Operation ID',
  operationIdFilterPlaceholder: 'Optional operation ID',
  applyFilters: 'Apply filters',
  resetFilters: 'Reset',
  showFilters: 'Show filters',
  hideFilters: 'Hide filters',

  // Profile Extended
  myProfile: 'My Profile',
  viewPersonalInfo: 'View your personal information',
  pleaseLoginToViewProfile: 'Please log in to view your profile.',
  failedToLoadProfile: 'Failed to load profile',

  // Footer
  footerText: 'mySign, crafted with',
  footerIn: 'in Azerbaijan © 2026 by',
  footerCopyright: '© 2026 mySign.az. All rights reserved.',
  privacyPolicy: 'Privacy Policy',
  termsOfService: 'Terms of Service',
  
  // Upload Document Extended
  review: 'Review',
  signers: 'Signers',
  tinCode: 'TIN Code',
  selectStorageOrganisation: 'Select Storage Organisation',
  chooseStorageOrganisation: 'Choose a storage organisation where your document will be uploaded.',
  noOrganisationsAvailable: 'No organisations available. Please contact support.',
  endpoint: 'Endpoint',
  selectDocument: 'Select Document',
  selectDocumentHint: 'Select a PDF file from your computer.',
  selectedFile: 'Selected file',
  documentSuccessfullyUploaded: 'Document Successfully Uploaded!',
  thankYouMessage: 'Thank you for using our service. Your document has been uploaded and signers will be notified.',
  goToDocumentList: 'Go to document list',
  signingLink: 'Signing Link',
  signingLinkCopied: 'Link copied',
  failedToLoadOrganisations: 'Failed to load organisations. Please refresh the page.',
  
  // Document Page
  document: 'Document',
  validityPeriod: 'Validity Period',
  from: 'From',
  to: 'To',
  organisation: 'Organisation',
  notAvailable: 'N/A',
  operationId: 'Operation ID',
  signed: 'Signed',
  pending: 'Pending',
  documentStatusDone: 'Done',
  documentStatusInProgress: 'In progress',
  type: 'Type',
  signingParties: 'Signing Parties',
  signingPartyStatusExpired: 'Expired',
  signingPartyStatusRejected: 'Rejected',
  signingPartyStatusReleased: 'Released',
  finLabel: 'FIN',
  noDocumentInfo: 'No document information available',
  signWithSima: 'Sign with Sima',
  release: 'Release',
  confirm: 'Confirm',
  releaseDialogMessage: 'You are releasing this document.',
  rejectDialogMessage: 'You are declining the signing request for this document.',
  releaseDialogConfirm: 'Release',
  rejectDialogConfirm: 'Decline',
  failedToUpdateSignStatus: 'Could not update signing status. Please try again.',
  reject: 'Reject',
  documentTabDetails: 'Details',
  documentTabDocument: 'Document',
  documentTabListLabel: 'Document sections',
  documentActions: 'Actions',
  documentActionsExpand: 'Show document actions',
  documentActionsCollapse: 'Hide document actions',
  documentDetailsResize: 'Resize document details panel',
  documentMoreDetails: 'More details',
  pdfRenderError: 'Could not display the PDF in the browser. Try opening it externally.',
  openPdfInBrowser: 'Open in browser',
  downloadDocument: 'Download',
  simaSignModalTitle: 'Sign with SIMA',
  simaScanQrDesktop: 'Scan the QR code with your SIMA app',
  simaScanQrMobile: 'Or scan the QR code with SIMA on another device',
  simaOpenSignerApp: 'Open Signer App',
  simaEnlargeQr: 'Enlarge QR code',
  simaEnlargedQr: 'Enlarged QR code',
  simaTapQrToZoom: 'Tap to enlarge',
  simaTapToCloseQr: 'Tap anywhere to close',
  simaSignWaiting: 'Waiting for signature…',
  simaSignThanks: 'Thank you. The document has been signed.',
  openDocument: 'Open Document',
  closeDocumentViewer: 'Close Document Viewer',
  openDocumentViewer: 'Open Document Viewer',
  noDocumentLoaded: 'Document preview is not loaded. Display the file to fetch it from the server.',
  loadDocument: 'Load Document',
  displayFile: 'Display file',
  rejectDocument: 'Reject Document',
  rejectDocumentReason: 'Please provide a reason for rejecting this document.',
  rejectionReason: 'Rejection Reason',
  documentGUIDNotFound: 'Document GUID not found.',
  failedToFetchDocumentInfo: 'Failed to fetch document information',
  errorFetchingDocumentInfo: 'Error fetching document information. Please try again later.',
  signingLinkAccessDenied: 'You do not have access to this signing link. Open the link that was sent to you, or sign in with the correct account.',
  failedToFetchDocument: 'Failed to fetch document',
  errorFetchingDocument: 'Error fetching document. Please try again later.',
  invalidResponseFormat: 'Invalid response format',
  failedToInitiateSigning: 'Failed to initiate signing process',
  documentSigningByOther: 'Document is signing by other counter party. Please try in 5 minutes.',
  errorInitiatingSigning: 'Error initiating signing process. Please try again later.',
  signWithUsbToken: 'Sign with SIMA USB Key',
  failedToReadCertificates: 'Failed to read certificates from USB token',
  noCertificatesFound: 'No certificates found. Please insert your USB token.',
  errorReadingCertificates: 'Error reading certificates. Please make sure your USB token is connected.',
  pleaseSelectCertificate: 'Please select a certificate',
  selectCertificate: 'Please select a certificate to sign the document',
  documentNotReady: 'Document information is not ready. Please wait for the page to load, then sign.',
  documentNotReadyNoSignerId: 'To sign with USB, open this document using your personal signing link (the link that was sent to you). This page was opened without your signer ID.',
  serialNumber: 'Serial Number',
  sign: 'Sign',
  missingDocumentInfo: 'Missing document information',
  failedToSignDocument: 'Failed to sign document',
  errorSigningDocument: 'Error signing document',
  failedToUploadSignedDocument: 'Failed to upload signed document',
  errorSigningWithUsbToken: 'Error signing document with USB token',

  signLinkStatusLabel: 'Status',
  signLinkStatusPending: 'Awaiting signature',
  signLinkStatusReleased: 'Approved (visa)',
  signLinkStatusUnknown: 'Unknown status',
  signLinkHello: 'Hello,',
  signLinkPageTitleSigner: 'Sign the document',
  signLinkPageTitleVisa: 'Approve the document',
  signLinkValidUntil: 'Valid until',
  signLinkSignedOn: 'Date',
  signLinkSignCta: 'Sign with Sima',
  signLinkVisaCta: 'Log in to approve',
  signLinkVisaNotice:
    'This is a Visa document. Log in to open it in mySign and approve it with one button.',
  signLinkViewIntro: 'To view the document in the browser on mySign.az,',
  signLinkLoginAction: 'log in',
  signLinkViewOr: 'or',
  signLinkRegisterAction: 'register',
  signLinkHowToSignTitle: 'How do I sign with Sima?',
  signLinkHowToVisaTitle: 'How do I approve?',
  signLinkHowToStep1: 'Tap the button and open the Sima app.',
  signLinkHowToStep2: 'Finish in the app. On a computer, scan the QR code.',
  signLinkHowToStep3: 'This page updates on its own when it is done.',
  signLinkContinueInSima: 'Continue in Sima',
  signLinkOpenSima: 'Open the Sima app',
  signLinkScanOtherDevice: 'Scan on another device',
  signLinkQrInstructions: 'Scan the QR code with the Sima app.',
  signLinkQrAlt: 'QR code for Sima',
  signLinkPolling: 'Checking signature status…',
  signLinkNotFoundTitle: 'Link not found',
  signLinkNotFoundBody: 'This link is invalid or does not exist. Open the invitation you were sent.',
  signLinkInvalidTitle: 'Invalid link',
  signLinkInvalidBody: 'This signing link is not valid. Open a new invitation link.',
  signLinkLoadError: 'The details could not be loaded. Try again.',
  signLinkRetry: 'Try again',
  signLinkLoading: 'Loading',
  signLinkPrivacy: 'Privacy',
  signLinkFooterNav: 'Links',
  signLinkThanks: 'Thank you.',
  signLinkCompletedSigned: 'The document is signed.',
  signLinkCompletedReleased: 'The document is approved.',
  signLinkLockGeneric: 'The document is locked right now. Try again in a moment.',
  signLinkStartError: 'Signing could not be started. Try again.',
  signLinkBlockedHint: 'Signing is not available right now.',
  signLinkAlreadyUsed: 'This signing link has already been used.',
  signLinkSeeOtherDocs: 'To see your other documents, you can log in to the system.',
  signLinkSeeOtherDocsCta: 'Log in',
};
